import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Heading,
  Icon,
  Skeleton,
  Stack,
} from '@chakra-ui/react';
import { PlusIcon } from '@heroicons/react/outline';
import { useParams } from 'react-router-dom';
import { useTranslations } from 'use-intl';

import { useGetOptionAssetQuery } from '@blockpulse3/graphql/hooks';
import { ErrorQueryCard } from '@blockpulse3/ui/commons';

import { OptionSummarySubscribersTable } from './OptionSummarySubscribersTable';
import { OptionSummarySubscribersTableEmpty } from './OptionSummarySusbcribersTableEmpty';

/* ** Temp ** */
type Props = unknown;

export function OptionSummarySubscribers(): JSX.Element {
  const i18nOptionSummarySubscribers = useTranslations('OptionSummarySubscribers');

  const { assetId = '', companyId = '' } = useParams();

  const { data, loading, error } = useGetOptionAssetQuery({
    variables: {
      getAssetInput: {
        assetId,
        companyId,
      },
    },
  });

  if (loading) {
    return (
      <Skeleton>
        <Card h="200px" />
      </Skeleton>
    );
  }

  if (error) {
    return <ErrorQueryCard h="200px" />;
  }

  if (!data) {
    return <ErrorQueryCard h="200px" />;
  }

  const option = data.getOptionAsset;
  const { grants } = option;
  const isEmpty = grants?.length === 0;

  return (
    <Card>
      <CardHeader
        as={Stack}
        direction={{ base: 'column', md: 'row' }}
        alignItems={{ base: 'flex-start', md: 'center' }}
        justifyContent="space-between"
      >
        <Heading size="md">{i18nOptionSummarySubscribers('Title')}</Heading>
        <Button isDisabled leftIcon={<Icon as={PlusIcon} boxSize="18px" />}>
          {i18nOptionSummarySubscribers('GrantButton')}
        </Button>
      </CardHeader>
      <CardBody>
        {isEmpty ? (
          <OptionSummarySubscribersTableEmpty />
        ) : (
          <OptionSummarySubscribersTable values={grants || []} />
        )}
      </CardBody>
    </Card>
  );
}

export type OptionSummarySubscribersProps = Props;
